<template>
  <div class="genus">
    <div class="header-breadcrumb">
      <p>属信息</p>
      <div class="header-utils">
        <div class="login_set">
          <el-tooltip class="item" effect="dark" content="下载管理" placement="bottom">
            <svg @click="loginSetVisible = true" style="cursor: pointer;" t="1658903168513" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4536" width="16" height="16"><path d="M855.89276 597.332338c4.26666 0 8.191986 2.687996 9.642651 6.527989l0.554666 2.431996 8.106653 56.319906c9.941317 3.839994 19.157301 8.874652 27.775953 14.762642l8.533319 6.14399 52.906579-21.333298a11.178648 11.178648 0 0 1 11.349314 2.218663l1.834664 2.474663 42.666596 73.81321a10.922648 10.922648 0 0 1-0.554666 11.391981l-2.00533 2.261329-45.226591 35.413275c1.279998 6.826655 1.706664 13.653311 1.706663 20.906632 0 4.821325-0.341333 9.471984-0.853332 14.079976l-0.853331 6.826655 45.653257 35.413275c3.071995 2.730662 4.522659 6.826655 3.669327 10.751982l-1.109331 2.901328-42.666596 73.813211a11.263981 11.263981 0 0 1-10.325316 5.290657l-2.901329-0.597332-53.333244-21.333298c-7.978653 6.399989-16.938638 11.818647-26.32529 16.511973l-9.51465 4.394659-8.106654 56.319906a10.965315 10.965315 0 0 1-8.106653 8.661319l-2.559995 0.298666h-85.333192a10.623982 10.623982 0 0 1-9.941316-6.527989l-0.725332-2.431996-8.106654-56.319906a138.325103 138.325103 0 0 1-27.733287-14.762642l-8.533319-6.14399-52.906578 21.333298a11.178648 11.178648 0 0 1-11.349315-2.218663l-1.87733-2.474662-42.666595-73.813211a10.922648 10.922648 0 0 1 0.597332-11.391981l1.962663-2.261329 45.226592-35.413275a166.741055 166.741055 0 0 1-0.682666-34.986608l0.682666-6.826655-45.226592-35.413275a10.367983 10.367983 0 0 1-3.669327-10.751982l1.109332-2.901328 42.666595-73.81321a11.263981 11.263981 0 0 1 10.367983-5.290658l2.858662 0.597332 52.906578 21.333298a161.279731 161.279731 0 0 1 26.794622-16.511973l9.471984-4.394659 8.106654-56.319906c0.725332-4.26666 4.095993-7.679987 8.191986-8.661319l2.474662-0.298666h85.333192z m-42.666595 149.333084c-35.413274 0-63.999893 28.586619-63.999894 63.999894s28.586619 63.999893 63.999894 63.999893 63.999893-28.586619 63.999893-63.999893-28.586619-63.999893-63.999893-63.999894z m-301.226165 42.666596v85.333191H213.333831v-85.333191h298.666169z m127.999787-639.998934v255.999574h170.666382l-298.666169 298.666169-298.666169-298.666169h170.666382v-255.999574h255.999574z m-85.333191 85.333192h-85.333192v255.999573H419.413488L512 583.252361l92.586512-92.586512H554.666596v-255.999573z" p-id="4537" fill="#999999"></path></svg>
          </el-tooltip>
        </div>
        <div class="dropdown">
          <el-dropdown placement="bottom">
            <span class="el-dropdown-link">
              <svg
                t="1646904841042"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="3880"
                width="16"
                height="16"
                style="cursor: pointer"
              >
                <path
                  d="M42.164706 999.905882V18.070588H572.235294c6.023529 0 6.023529 0 6.02353 6.02353L873.411765 319.247059v90.352941h-90.352941v-42.164706c0-6.023529-6.023529-18.070588-6.02353-24.094118L566.211765 132.517647c-18.070588-12.047059-36.141176-18.070588-54.211765-18.070588H192.752941c-30.117647 0-60.235294 24.094118-60.235294 60.235294v686.682353c0 30.117647 24.094118 60.235294 60.235294 60.235294h686.682353v90.352941H42.164706z"
                  fill="#999999"
                  p-id="3881"
                ></path>
                <path
                  d="M680.658824 807.152941v-72.282353h295.152941V584.282353h-295.152941V512L457.788235 662.588235l222.870589 144.564706zM536.094118 277.082353H222.870588c-18.070588 0-30.117647-12.047059-30.117647-30.117647v-24.094118c0-18.070588 12.047059-30.117647 30.117647-30.117647h313.22353c18.070588 0 30.117647 12.047059 30.117647 30.117647v24.094118c0 18.070588-12.047059 30.117647-30.117647 30.117647zM445.741176 433.694118H216.847059c-12.047059 0-24.094118-12.047059-24.094118-24.094118v-36.141176c0-12.047059 12.047059-24.094118 24.094118-24.094118h228.894117c12.047059 0 24.094118 12.047059 24.094118 24.094118v36.141176c0 12.047059-12.047059 24.094118-24.094118 24.094118z"
                  fill="#999999"
                  p-id="3882"
                ></path>
              </svg>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <p style="font-size: 16px;">
                  <el-upload
                    class="sequence-upload"
                    style="display:inline-block"
                    action="/"
                    :show-file-list="false"
                    :auto-upload="false"
                    :on-change="getExcelFile"
                    accept=".xlsx"
                  >
                    <span
                      onMouseOver="this.style.color='#05579e'"
                      onMouseOut="this.style.color='#666'"
                      >导入excel</span
                    >
                  </el-upload>
                  <span
                    style="font-size: 12px;"
                    onMouseOver="this.style.color='#05579e'"
                    onMouseOut="this.style.color='#666'"
                    @click="downloadWebData"
                    >(下载模版)</span
                  >
                </p>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="middle-box">
      <div class="search-box">
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline"
          ref="ruleForm"
        >
          <el-form-item label="名称" prop="user">
            <el-input
              v-model="formInline.user"
              placeholder="请输入"
              class="user-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-col :span="11">
              <el-form-item prop="startDate">
                <el-date-picker
                  v-model="formInline.startDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="”yyyy-MM-dd”"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="更新时间">
            <el-col :span="11">
              <el-form-item prop="undateDate">
                <el-date-picker
                  v-model="formInline.undateDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="”yyyy-MM-dd”"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('ruleForm')">重置条件</el-button>
            <el-button type="primary" @click="getData">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-box">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :default-sort="{ prop: 'genusName', order: 'ascending' }"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="genusName" label="Genus" width="500" sortable>
            <template slot-scope="scope">
              <el-input
                v-if="nameInputActive === scope.$index"
                v-model="nameInput"
                placeholder="请输入内容"
                class="nameInput"
              ></el-input>
              <span v-else style="line-height:30px">{{
                scope.row.genusName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="Create time" width="500">
          </el-table-column>
          <el-table-column prop="updateTime" label="Update time" width="350">
          </el-table-column>
          <el-table-column label="">
            <template slot-scope="scope">
              <div
                class="disappear"
                :class="{ block: nameInputActive !== scope.$index }"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="top"
                >
                  <svg
                    @click="handleEdit(scope.$index, scope.row)"
                    t="1648024164242"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4326"
                    width="16"
                    height="16"
                  >
                    <path
                      d="M512 25.6C243.2 25.6 25.6 243.2 25.6 512c0 268.8 217.6 486.4 486.4 486.4 268.8 0 486.4-217.6 486.4-486.4C998.4 243.2 780.8 25.6 512 25.6z m76.8 524.8l-128 128-6.4 6.4c-6.4 6.4-12.8 6.4-19.2 6.4l-38.4 12.8-76.8 38.4c-19.2 6.4-44.8-19.2-38.4-38.4l25.6-64 19.2-51.2c0-6.4 6.4-12.8 12.8-19.2l38.4-38.4 153.6-153.6 121.6 121.6-64 51.2z m147.2-153.6c-6.4 12.8-12.8 25.6-19.2 32l-19.2 19.2L576 326.4l19.2-19.2 19.2-19.2c32-19.2 76.8-19.2 102.4 6.4 25.6 38.4 32 70.4 19.2 102.4z"
                      p-id="4327"
                    ></path>
                  </svg>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                >
                  <svg
                    @click="getDelIndex(scope.row)"
                    t="1648024716931"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4471"
                    width="16"
                    height="16"
                  >
                    <path
                      d="M844.8 326.4c-19.2 0-38.4 19.2-38.4 38.4v550.4c0 19.2-19.2 38.4-38.4 38.4H256c-19.2 0-38.4-19.2-38.4-38.4V364.8c0-19.2-12.8-38.4-38.4-38.4-19.2 0-38.4 19.2-38.4 38.4v550.4C147.2 972.8 192 1024 256 1024h512c64 0 115.2-51.2 115.2-115.2v-544c0-19.2-19.2-38.4-38.4-38.4zM435.2 761.6V364.8c0-19.2-12.8-38.4-38.4-38.4-19.2 0-38.4 19.2-38.4 38.4V768c0 19.2 12.8 38.4 38.4 38.4 25.6-6.4 38.4-19.2 38.4-44.8z m224 0V364.8c0-19.2-19.2-38.4-38.4-38.4s-38.4 19.2-38.4 38.4V768c0 19.2 19.2 38.4 38.4 38.4 19.2-6.4 38.4-19.2 38.4-44.8z m326.4-582.4H806.4v-70.4C806.4 51.2 755.2 0 697.6 0H326.4c-64 0-108.8 44.8-108.8 108.8v76.8H38.4C19.2 179.2 0 198.4 0 217.6s19.2 32 38.4 32h947.2c19.2 0 38.4-12.8 38.4-32s-19.2-38.4-38.4-38.4z m-256 0H288v-70.4c0-19.2 19.2-38.4 38.4-38.4h371.2c19.2 0 32 12.8 32 38.4v70.4z m0 0"
                      p-id="4472"
                    ></path>
                  </svg>
                </el-tooltip>
              </div>
              <div
                class="disappear"
                :class="{ appear: nameInputActive === scope.$index }"
              >
                <img
                  @click="handleSave(scope.$index, scope.row)"
                  src="@/assets/img/backstage-genus-save.png"
                  alt="保存"
                  style="margin-right:21px;cursor: pointer;"
                />
                <img
                  @click="handleCancel(scope.$index, scope.row)"
                  src="@/assets/img/backstage-genus-close.png"
                  alt="关闭"
                  style="cursor: pointer;"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="add-box" :class="{ marginTop: tableData.length == 0 }">
          <p @click="handleAdd">
            <i class="el-icon-circle-plus-outline"></i>
            <span>点击添加属</span>
          </p>
        </div>
      </div>
      <div
        class="delete-box"
        @click="openDelWindow"
        v-if="multipleSelection.length > 1"
      >
        <i class="el-icon-delete"></i>
        <span>删除</span>
      </div>
      <div class="tip-box">
        <el-dialog title="删除" :visible.sync="dialogVisible">
          <div class="dialog-content">
            <div class="content-left">
              <img src="../../../assets/img/backstage-genus-tip.png" alt="" />
            </div>
            <div class="content-right">
              <h2>确认删除？</h2>
              <h5>此操作将所属的物种，一并删除，是否继续？</h5>
            </div>
          </div>
          <div class="caozuo">
            <button @click="removeSingle">
              确定
            </button>
            <button
              @click="
                dialogVisible = false
                delrow = null
              "
            >
              取消
            </button>
          </div>
        </el-dialog>
      </div>
      <div class="tip-box">
        <el-dialog title="删除" :visible.sync="dialogVisible1">
          <div class="dialog-content">
            <div class="content-left">
              <img src="../../../assets/img/backstage-genus-tip.png" alt="" />
            </div>
            <div class="content-right">
              <h2>确认删除？</h2>
              <h5>此操作将所属的物种，一并删除，是否继续？</h5>
            </div>
          </div>
          <div class="caozuo">
            <button @click="removeMultiple">
              确定
            </button>
            <button @click="dialogVisible1 = false">取消</button>
          </div>
        </el-dialog>
      </div>
      <div class="tip-box">
        <el-dialog title="提示" :visible.sync="dialogFail">
          <p style="line-height:14px">无效数据</p>
          <div class="dialog-fail-content">
            <el-table
              :data="failList"
              style="width: 100%"
              class="fail-table"
              max-height="250"
            >
              <el-table-column
                prop="number"
                label="行号"
                v-if="isExcel"
                width="60px"
              >
              </el-table-column>
              <el-table-column prop="name" label="名称" width="260px">
                <template slot-scope="{ row }">
                  <span>{{ row.name || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="reason"
                label="错误原因"
                style="color:#f56c6c"
              >
                <template slot-scope="{ row }">
                  <span style="color: #f56c6c">{{ row.reason || '-' }}</span>
                </template>
              </el-table-column>
            </el-table>
            <p style="line-height:14px;margin-top:20px">
              共{{ failList.length }}条
            </p>
          </div>
        </el-dialog>
      </div>
      <!-- 设置下载是否需要登录 -->
      <div class="tip-box">
        <el-dialog @closed="loginSetVal = loginSetValInitial" title="下载管理" :visible.sync="loginSetVisible">
          <div class="dialog-content">
            <div class="content-left">
              <img src="../../../assets/img/backstage-genus-tip.png" alt="" />
            </div>
            <div class="content-right">
              <h2>下载数据时，是否需要验证登录。</h2>
              <el-radio class="radioItem" style="margin:20px 0" v-model="loginSetVal" label='true'>需要</el-radio>
              <el-radio class="radioItem"  v-model="loginSetVal" label='false'>不需要</el-radio>
            </div>
          </div>
          <div class="caozuo">
            <button @click="loginSet">
              确定
            </button>
            <button
              @click="loginSetVisible = false"
            >
              取消
            </button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'
import { Message } from 'element-ui'
export default {
  name: 'Genus',
  data () {
    return {
      formInline: {
        user: '',
        startDate: '',
        undateDate: ''
      },
      tableData: [],
      multipleSelection: [],
      nameInputActive: -1,
      newBuild: false, // 新建
      nameInput: '',
      dialogVisible: false,
      dialogVisible1: false,
      delrow: null,
      excelFile: null,
      dialogFail: false,
      failList: [],
      isExcel: true,
      loginSetVisible: false,
      loginSetVal: '',
      loginSetValInitial: '',
      settingUuid: ''
    }
  },
  mounted () {
    this.getSettingByModule()
    this.getData()
  },
  methods: {
    getDelIndex (row) {
      this.delrow = row
      this.dialogVisible = true
    },
    getData () {
      let { startDate, undateDate } = this.formInline
      let startCreateTime
      let endCreateTime
      let startUpdateTime
      let endUpdateTime
      if (startDate && startDate.length === 2) {
        startCreateTime = startDate[0]
        startCreateTime = startCreateTime.slice(1)
        startCreateTime = startCreateTime.slice(0, startCreateTime.length - 1)
        endCreateTime = startDate[1]
        endCreateTime = endCreateTime.slice(1)
        endCreateTime = endCreateTime.slice(0, endCreateTime.length - 1)
      } else {
        startCreateTime = ''
        endCreateTime = ''
      }
      if (undateDate && undateDate.length === 2) {
        startUpdateTime = undateDate[0]
        startUpdateTime = startUpdateTime.slice(1)
        startUpdateTime = startUpdateTime.slice(0, startUpdateTime.length - 1)
        endUpdateTime = undateDate[1]
        endUpdateTime = endUpdateTime.slice(1)
        endUpdateTime = endUpdateTime.slice(0, endUpdateTime.length - 1)
      } else {
        startUpdateTime = ''
        endUpdateTime = ''
      }
      api
        .getGenusList(
          this.formInline.user,
          startCreateTime,
          endCreateTime,
          startUpdateTime,
          endUpdateTime
        )
        .then(res => {
          if (res.data.code === 200) {
            this.tableData = res.data.data
            this.tableData.forEach(item => {
              item.createTime = item.createTime.slice(0, 10)
              item.updateTime = item.updateTime.slice(0, 10)
            })
          } else {
            Message.error(`${res.data.msg}`)
          }
        })
    },
    cancelActive () {
      this.nameInputActive = -1
    },
    // 重置
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.getData()
    },
    // 勾选框
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 修改
    handleEdit (index, row) {
      this.nameInput = row.genusName
      this.nameInputActive = index
    },
    // 删除单个弹窗
    removeSingle () {
      api.genusDelete(this.delrow.genusId).then(res => {
        if (res.data.code === 200) {
          Message.success('已删除')
          this.getData()
          this.dialogVisible = false
        } else {
          Message.error(`${res.data.msg}`)
        }
        this.delrow = null
      })
    },
    // 勾选多个打开删除弹窗
    openDelWindow () {
      this.dialogVisible1 = true
    },
    // 删除多个弹窗
    removeMultiple () {
      let list = []
      this.multipleSelection.forEach(item => {
        list.push(item.genusId)
      })
      this.delete(list)
    },
    // 批量删除属
    delete (list) {
      api.genusDeleteList(list).then(res => {
        if (res.data.code === 200) {
          Message.success(`${res.data.msg}`)
        } else {
          Message.error(`${res.data.msg}`)
        }
        this.getData()
        this.dialogVisible1 = false
      })
    },
    // 保存
    handleSave (index, row) {
      if (this.newBuild) {
        if (this.nameInput) {
          api.postGenusIncrease(this.nameInput).then(res => {
            if (res.data.code === 200) {
              Message.success('添加成功')
              // let lastIndex = this.tableData.length - 1
              // this.tableData[lastIndex].genusName = this.nameInput
              this.getData()
              this.cancelActive()
              this.newBuild = false
            } else {
              Message.error(`${res.data.msg}`)
            }
          })
        } else {
          Message.error('名称不能为空')
        }
      } else {
        let a = this.tableData[index].genusName === this.nameInput
        if (a) {
          this.cancelActive()
        } else {
          let obj = {}
          obj.genusId = row.genusId
          obj.genusName = this.nameInput
          api.postGenusUpdate(obj).then(res => {
            if (res.data.code === 200) {
              Message.success('修改成功')
              this.tableData[index].genusName = obj.genusName
              this.tableData[index].updateTime = this.getTime()
              this.getData()
              this.cancelActive()
            } else {
              Message.error(`${res.data.msg}`)
            }
          })
        }
      }
    },
    // 取消
    handleCancel (index, row) {
      if (this.newBuild) {
        this.tableData.length = this.tableData.length - 1
        this.cancelActive()
        this.newBuild = false
      }
      this.cancelActive()
    },
    // 添加
    handleAdd () {
      if (!this.newBuild) {
        this.newBuild = true
        this.nameInput = ''
        let obj = {}
        obj.name = null
        obj.createTime = this.getTime()
        obj.updateTime = this.getTime()
        this.tableData.push(obj)
        this.nameInputActive = this.tableData.length - 1
      }
    },
    // 获取当前时间
    getTime () {
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      mm = mm < 10 ? '0' + mm : mm
      let dd = new Date().getDate()
      dd = dd < 10 ? '0' + dd : dd
      return yy + '-' + mm + '-' + dd
    },
    // 获取上传的文件
    getExcelFile (file) {
      this.excelFile = file
    },
    // 下载模板
    downloadWebData () {
      let element = document.createElement('a')
      element.setAttribute('href', '/base/downloadWebData?fullpath=plugins/alage/genusTemplate.xlsx')
      element.setAttribute('download', 'genusTemplate.xlsx')
      element.style.display = 'none'
      element.click()
      // window.location.href =
      //   '/base/downloadWebData?fullpath=plugins/alage/genusTemplate.xlsx'
    },
    // 表头检测
    getExcelFileContent () {
      if (this.excelFile) {
        let FileRaw = new FormData()
        FileRaw.append('file', this.excelFile.raw)
        api.getExcelFileContent(FileRaw, 'genus').then(res => {
          if (res.data.code === 200) {
            if (res.data.data.length === 0) {
              Message.error('表格无数据')
            } else {
              this.importTemplateByGenus(res.data.data)
            }
          } else {
            Message.error(res.data.msg)
          }
          this.excelFile = null
        })
      }
    },
    // 导入数据(excel)
    importTemplateByGenus (list) {
      api.importTemplateByGenus(list).then(res => {
        if (res.data.code === 200) {
          if (res.data.data.length !== 0) {
            // 打开弹窗
            this.failList = res.data.data
            this.dialogFail = true
            this.isExcel = true
          } else {
            Message.success(`${res.data.msg}`)
            this.getData()
          }
        } else {
          Message.error(`${res.data.msg}`)
        }
      })
    },
    // 获取下载设置
    getSettingByModule () {
      api.getSettingByModule().then((res) => {
        if (res.data.code === 200) {
          this.loginSetValInitial = res.data.data[0].settingValue + ''
          this.loginSetVal = this.loginSetValInitial
          this.settingUuid = res.data.data[0].settingUuid
        } else {
          Message.error(res.data.msg)
        }
      })
    },
    // 更新下载设置
    updateSetting () {
      let obj = {
        settingUuid: this.settingUuid,
        defaultValue: true,
        settingValue: this.loginSetVal === 'true'
      }
      api.updateSetting(obj).then((res) => {
        if (res.data.code === 200) {
          Message.success('设置成功')
        } else {
          Message.error(res.data.msg)
        }
        this.getSettingByModule()
      })
    },
    // 下载是否需要登录验证
    loginSet () {
      this.loginSetValInitial = this.loginSetVal
      this.loginSetVisible = false
      this.updateSetting()
    }
  },
  watch: {
    nameInput: function () {
      // 只能输入中文和数字
      // this.nameInput = this.nameInput.replace(/[^0-9\u4e00-\u9fa5]/g,'')
    },
    excelFile: 'getExcelFileContent'
  }
}
</script>

<style lang="scss" scoped>
.genus {
  padding: 11px;
  .header-breadcrumb {
    margin-bottom: 14px;
    width: 100%;
    height: 50px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(4, 0, 0, 0.16);
    border-radius: 4px;
    line-height: 50px;
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    padding-left: 20px;
    box-sizing: border-box;
    position: relative;
    .header-utils {
      height: 100%;
      position: absolute;
      top: 0;
      right: 20px;
      // width: 50px;
      display: flex;
      align-items: center;
      .dropdown {
        box-sizing: border-box;
        margin-right: 15px;
        padding-top: 5px;
        display: flex;
        align-items: center;
        >>> .el-dropdown-menu {
          .el-dropdown-menu__item {
            width: 300px;
          }
        }
      }
      .login_set{
        margin-right: 20px;
      }
    }
  }
  .middle-box {
    background-color: #fff;
    width: 100%;
    box-shadow: 0px 0px 6px 0px rgba(4, 0, 0, 0.16);
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
    .search-box {
      text-align: right;
      margin-bottom: 40px;
      position: relative;
      .el-form-item {
        margin-bottom: 0;
        >>> .el-form-item__label {
          color: #333;
          line-height: 30px;
        }
        >>> .el-form-item__content {
          height: 30px;
          line-height: 30px;
          .el-input__inner {
            height: 30px;
            line-height: 30px;
            // width: 350px;
            .el-input__icon,
            .el-range-separator {
              height: auto;
            }
          }
          .user-input {
            .el-input__inner {
              width: 177px;
            }
          }
          .el-button {
            height: 30px;
            font-size: 14px;
            box-sizing: border-box;
            padding: 2px 18px;
            border-radius: 4px;
          }
          .el-button--primary {
            background: $theme_color;
            border-color: $theme_color;
          }
          .el-input.is-active .el-input__inner,
          .el-input__inner:focus,
          .el-range-editor.is-active,
          .el-range-editor.is-active:hover {
            border-color: $theme_color;
          }
          .el-button--default {
            padding-left: 0;
            padding-right: 0;
            color: #333333;
            border: none;
            background-color: #fff;
            &:hover {
              color: $theme_color;
            }
          }
        }
      }
      &::after {
        display: block;
        content: '';
        position: absolute;
        bottom: -20px;
        left: 0;
        height: 1px;
        width: 100%;
        background-color: #dddddd;
      }
    }
    .table-box {
      .el-table::before {
        height: 0;
      }
      .el-table >>> .el-table__empty-block {
        display: none;
      }
      .el-table >>> .el-table__body {
        border-collapse: separate;
        border-spacing: 0 10px;
      }
      .el-table >>> thead {
        color: #333;
        margin-bottom: 10px;
        th {
          line-height: 30px;
        }
      }
      .el-table >>> .el-table__cell {
        padding: 12px 0;
      }
      .el-table >>> td.el-table__cell,
      .el-table >>> th.el-table__cell.is-leaf {
        // border-bottom: none;
        border-top: 1px solid rgba(40, 40, 40, 0.14);
        border-bottom: 1px solid rgba(40, 40, 40, 0.14);
      }
      .el-table >>> .el-table__row td:first-child,
      .el-table >>> tr th:first-child {
        border-left: 1px solid rgba(40, 40, 40, 0.14);
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      .el-table >>> .el-table__row td:last-child,
      .el-table >>> tr th:nth-last-child(2) {
        border-right: 1px solid rgba(40, 40, 40, 0.14);
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
      .el-table >>> th.el-table__cell > .cell {
        padding-left: 13px;
        padding-right: 13px;
      }
      .el-table >>> .caret-wrapper {
        position: absolute;
        top: -4px;
      }
      .el-table >>> .ascending .sort-caret.ascending {
        border-bottom-color: $theme_color-hover;
      }
      .el-table >>> .descending .sort-caret.descending {
        border-top-color: $theme_color-hover;
      }
      .el-input >>> .el-input__inner {
        border-color: #fff;
        padding: 0;
        height: 30px;
        line-height: 30px;
      }
      .nameInput >>> .el-input__inner {
        border-color: #dcdfe6;
      }
      .el-input.is-active >>> .el-input__inner,
      >>> .el-input__inner:focus {
        border-color: $theme_color;
      }
      >>> .el-checkbox__input.is-checked .el-checkbox__inner,
      >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: $theme_color;
        border-color: $theme_color;
      }
      >>> .el-checkbox__inner:hover,
      >>> .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: $theme_color;
      }
      .el-table >>> .el-table__row {
        // box-shadow: 0px 0px 4px 0px rgba(40, 40, 40, 0.14);
        border: 1px solid rgb(40, 40, 40);
        border-radius: 4px;
      }
      .disappear {
        display: none;
        .icon {
          cursor: pointer;
          margin-right: 21px;
          path {
            fill: #666;
          }
          &:hover {
            path {
              fill: $theme_color;
            }
          }
          &:last-child {
            margin-right: 0;
            &:hover {
              path {
                fill: #f56c6c;
              }
            }
          }
        }
      }
      .appear {
        display: block;
      }
      >>> .el-table__body tr:hover .block {
        display: block;
      }
    }
    .add-box {
      height: 46px;
      background: #ffffff;
      border: 1px solid rgba(40, 40, 40, 0.14);
      border-radius: 4px;
      p {
        height: 100%;
        display: flex;
        padding: 8px 14px;
        box-sizing: border-box;
        align-items: center;
        width: 140px;
        cursor: pointer;
        color: #999999;
        span {
          margin-left: 8px;
          color: #666;
          font-size: 14px;
        }
        &:hover {
          color: $theme_color;
          span {
            color: $theme_color;
          }
        }
      }
    }
    .marginTop {
      margin-top: 10px;
    }
    .delete-box {
      position: fixed;
      top: 85%;
      left: 50%;
      transform: translateX(-50%);
      width: 193px;
      height: 46px;
      background: #f1f2f4;
      box-shadow: 0px 0px 16px 0px rgba(40, 40, 40, 0.2);
      border-radius: 23px;
      cursor: pointer;
      font-size: 14px;
      color: #f56c6c;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-icon-delete {
        font-size: 16px;
        margin-right: 18px;
      }
    }
  }
  .tip-box {
    >>> .el-dialog {
      box-shadow: none !important;
      width: 482px !important;
      // height: 218px;
      margin-top: 30vh !important;
    }
    >>> .el-dialog .el-dialog__header {
      font-weight: 550;
      line-height: 50px;
      color: #333;
    }
    >>> .el-dialog .el-dialog__body {
      line-height: 50px;
    }
    >>> .el-dialog .dialog-content {
      overflow: hidden;
      width: 100%;
    }
    >>> .el-dialog .caozuo {
      margin-top: 30px;
      width: 100%;
      height: 50px;
      text-align: right;
    }
    >>> .el-dialog .caozuo button {
      width: 80px;
      height: 34px;
      border-radius: 2px;
      border: 0;
      outline: none;
      cursor: pointer;
    }
    >>> .el-dialog__header {
      padding: 0 20px;
    }
    >>> .el-dialog__body {
      padding: 10px 20px;
    }
    >>> .el-dialog .caozuo button:first-child {
      background: $theme_color;
      color: #fff;
      border: 1px solid $theme_color;
      margin-right: 10px;
    }
    >>> .el-dialog .caozuo button:last-child {
      background: #fff;
      color: #999999;
      border: 1px solid #999;
    }
    >>> .el-dialog .dialog-content .content-right {
      width: 75%;
      float: right;
      text-align: left;
    }
    >>> .el-dialog .dialog-content .content-left {
      width: 25%;
      height: 40px;
      line-height: 0px;
      float: left;
      text-align: right;
    }
    >>> .el-dialog .dialog-content .content-left img {
      padding: 5px 20px;
    }
    >>> .el-dialog .dialog-content .content-right h2 {
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      font-weight: 500;
      color: #666;
    }
    >>> .el-dialog .dialog-content .content-right h5 {
      font-size: 14px;
      line-height: 30px;
      font-weight: 500;
      height: 30px;
      color: #999;
    }
    >>> .el-dialog .dialog-content .content-right .radioItem{
      display: block;
      .el-radio__label{
        color: #999;
      }
      .el-radio__input .el-radio__inner{
        border-color: #999;
      }
      .el-radio__input.is-checked .el-radio__inner{
        background: #fff;
        &::after{
          width: 6px;
          height: 6px;
          background-color: #175690;
        }
      }
      .el-radio__input.is-checked + .el-radio__label{
        color: #666;
      }
    }
    >>> .el-dialog__headerbtn:focus .el-dialog__close,
    >>> .el-dialog__headerbtn:hover .el-dialog__close {
      color: $theme_color;
    }
  }
}

.el-dropdown-menu__item {
  padding: 5px 10px;
  color: #666;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #fff;
  color: #666;
}
.excel {
  &:hover {
    color: $theme_color;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/backstage/genus/genus.vue